export type ContentKey = "article" | "event" | "vod" | "poll" | "quiz" | "contentListing";

// 255 to match the current doc-path length support — applied uniformly across
// every content type, including dynamic/schema-based ones (see getTitleFieldMaxLength).
const DEFAULT_TITLE_MAX = 255;

export const TITLE_MAX: Record<ContentKey, number> = {
  article: 255,
  event: 255,
  vod: 255,
  poll: 255,
  quiz: 255,
  contentListing: 255,
};

export const getTitleMax = (kind?: string): number =>
  TITLE_MAX[(kind || "").toLowerCase() as ContentKey] ?? DEFAULT_TITLE_MAX;

export const buildTitleValidation = (kind?: string) => {
  const max = getTitleMax(kind);
  return [
    {
      type: "maxLength" as const,
      value: max,
      message: `${max} characters max`,
    },
  ];
};
